<template>
  <b-dropdown
    ref="dropdown"
    position="is-bottom-left"
    :disabled="isDisabled"
  >
    <template #trigger="{ active }">
      <button-outlined
        :icon-left="iconLeft"
        :icon-right="iconRight"
      >{{ label }}</button-outlined>
    </template>

    <b-dropdown-item style="min-width: 330px" :focusable="false" custom>
      <div class="filter-dropdown-container">
        <slot></slot>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "FilterFieldDropdown",
  props: {
    label: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    iconLeft: {
      type: String
    },
    iconRight: {
      type: String
    },
  },
  methods: {
    toggle() {
      this.$refs.dropdown.toggle()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.filter-dropdown-container {
  max-height: 600px;
  overflow: auto;
}

</style>
